import { render } from "./feedLayout.vue?vue&type=template&id=a4dd8ac8"
import script from "./feedLayout.vue?vue&type=script&lang=js"
export * from "./feedLayout.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__